import React, { type PropsWithChildren, useCallback, useMemo, useState } from 'react'
import { HeaderContext } from './HeaderContext'

export const HeaderContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [portalRef, setPortalRefState] = useState<React.RefObject<HTMLDivElement>>()
  const [portalElement, setPortalElement] = useState<HTMLDivElement | null>(null)

  // The layout registers its ref from an effect, once the target is mounted.
  const setPortalRef = useCallback((ref: React.RefObject<HTMLDivElement>) => {
    setPortalRefState(ref)
    setPortalElement(ref.current)
  }, [])

  const contextProps = useMemo(() => ({ portalRef, portalElement, setPortalRef }), [portalRef, portalElement, setPortalRef])

  return <HeaderContext.Provider value={contextProps}>{children}</HeaderContext.Provider>
}
